// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import BritishIndianOceanTerritory from '../_raw/flag/icon_flag_british_indian_ocean_territory.png';

export default () => <img src={BritishIndianOceanTerritory} alt="BritishIndianOceanTerritory" />;
